import * as ModalKeys from "Flocknote/GlobalComponents/Modal/contentKeys";

import externalNavigate from "Utilities/externalNavigate";

export const buttonFuncConfig = {
  goToExternalPage: (externalPage) => {
    externalNavigate(externalPage);
  },
  goToInternalPage: (internalPage) => {
    // console.log("internalPage running", internalPage);
    // window.fnReactBus.goToUrl(internalPage);
    window.location = internalPage;
  },
  goToInternalPageReload: (internalPage) => {
    window.location = internalPage;
  },
  openModal: (modalKey) => {
    window.fnReactBus.openModal(ModalKeys[modalKey], {});
  },
};
